export const TOGGLE_PROMO = 'toggle_promo'
export const TOGGLE_PRIVACY ='toggle_privacy'